if (!customElements.get('wlsn-bundle-tabs')) {
    class WLSNBundleTabs extends HTMLElement {
        constructor() {
            super();

            this.classes = {
                activeTab: 'is-active',
                activeSection: 'wlsn-bundle-tabs-active',
                hidden: 'is-hidden',
                ready: 'wlsn-bundle-tabs-ready',
                tab: 'js-wlsn-bundle-tab'
            };

            this.elements = {
                tabs: [...this.querySelectorAll(`.${this.classes.tab}`)]
            };

            this.linkClickHandler = this.handleLinkClick.bind(this);
            this.sectionSelectHandler = this.handleSectionSelect.bind(this);
            this.blockSelectHandler = this.handleBlockSelect.bind(this);
        }

        connectedCallback() {
            if (!this.elements.tabs.length) return;

            this.elements.tabs.forEach((tab) => {
                tab.addEventListener('click', () => this.activate(tab));
            });

            document.addEventListener('click', this.linkClickHandler);

            document.addEventListener('shopify:section:select', this.sectionSelectHandler);
            document.addEventListener('shopify:block:select', this.blockSelectHandler);

            const defaultTab = this.elements.tabs.find((tab) => tab.classList.contains(this.classes.activeTab)) || this.elements.tabs[0];
            const anchorTab = this.getTabByAnchor(window.location.hash.slice(1));
            const isHiddenOnLoad = this.classList.contains(this.classes.hidden);

            // Hidden on load - keep everything hidden until a tab anchor is opened
            if (!isHiddenOnLoad || anchorTab) {
                this.reveal();
                this.activate(anchorTab || defaultTab);
            }
            document.documentElement.classList.add(this.classes.ready);

            if (anchorTab && (anchorTab !== defaultTab || isHiddenOnLoad)) {
                this.scrollToTabs();
            }
        }

        disconnectedCallback() {
            document.removeEventListener('click', this.linkClickHandler);
            document.removeEventListener('shopify:section:select', this.sectionSelectHandler);
            document.removeEventListener('shopify:block:select', this.blockSelectHandler);
        }

        getTabByAnchor(anchor) {
            if (!anchor) return null;
            return this.elements.tabs.find((tab) => tab.dataset.anchor === anchor) || null;
        }

        getShop(tab) {
            const targetClass = tab.dataset.targetClass;
            if (!targetClass) return null;

            return document.querySelector(`.${targetClass}`);
        }

        reveal() {
            this.classList.remove(this.classes.hidden);
        }

        activate(tab) {
            this.elements.tabs.forEach((item) => {
                const isActive = item === tab;

                item.classList.toggle(this.classes.activeTab, isActive);
                item.setAttribute('aria-selected', isActive ? 'true' : 'false');

                const shop = this.getShop(item);
                if (shop) shop.classList.toggle(this.classes.activeSection, isActive);
            });

            this.dataset.activeTab = tab.dataset.blockId;
            const shop = this.getShop(tab);
            if (shop) {
                shop.thumbs?.update();
                shop.swiper?.update();
            }
        }

        scrollToTabs() {
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            this.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        }

        handleLinkClick(event) {
            const link = event.target.closest('a[href*="#"]');
            if (!link || link.pathname !== window.location.pathname) return;

            const tab = this.getTabByAnchor(link.hash.slice(1));
            if (!tab) return;

            event.preventDefault();
            this.reveal();
            this.activate(tab);
            this.scrollToTabs();
            history.replaceState(null, '', link.hash);
        }

        handleSectionSelect(event) {
            const sectionId = `shopify-section-${event.detail.sectionId}`;

            if (this.closest('.shopify-section')?.id === sectionId) {
                this.reveal();
                this.activate(this.elements.tabs.find((item) => item.classList.contains(this.classes.activeTab)) || this.elements.tabs[0]);
                return;
            }

            const tab = this.elements.tabs.find((item) => {
                const section = this.getShop(item)?.closest('.shopify-section');
                return section && section.id === sectionId;
            });

            if (tab) {
                this.reveal();
                this.activate(tab);
            }
        }

        handleBlockSelect(event) {
            if (!this.elements.tabs.includes(event.target)) return;

            this.reveal();
            this.activate(event.target);
        }
    }

    customElements.define('wlsn-bundle-tabs', WLSNBundleTabs);
}
